import './certificate.scss';
import { setupLayout } from '../../../Shared/layout';
import '@fancyapps/fancybox';

setupLayout();